/**
 * slider Instagram list
 * Instagram 列表点击显示弹窗
 * 
 */

const modalDialog = document.getElementById('insPostModal');
const postList = document.querySelectorAll('.t4s-instagram-item');
const slideList = document.getElementById('slick-track');
const postItem = slideList.querySelectorAll('.slide-item');
const prevBtn = document.getElementById('slick_left_arrow');
const nextBtn = document.getElementById('slick_right_arrow');
const carouselItemList = document.querySelectorAll('.carousel__slide');
// const overlayBG = document.querySelector('.t4s-close-overlay.t4s-op-0');
const content = document.querySelectorAll('.ins-post__content');
var currentIndex = 0;
var toggleBtn;
var postContent;


document.addEventListener('DOMContentLoaded', function () {
  // 点击弹出
  postList.forEach((e, i) => {
    e.setAttribute("data-id", i);
    e.addEventListener('click', function() {
      // const id = this.dataset.id;
      
      if (modalDialog.style.display === 'none') {
        modalDialog.style.display = 'block';
        currentIndex = this.getAttribute("data-id");
        updateSlider();
        checkOverflow();
      } else {
        currentIndex = 0;
        clearActive();
        modalDialog.style.display = 'none';
      }
    });
  });

  // 点击关闭按钮
  const closeBtn = document.getElementById('closeBtn');
  closeBtn.addEventListener('click', function () {
    currentIndex = 0;
    clearActive();
    modalDialog.style.display = 'none';
  });

  // 更新位置
  function updateSlider() {
    slideList.style.transform = `translateX(-${currentIndex * 100}%)`;

    var carouselItem = carouselItemList[currentIndex];
    carouselItem.classList.toggle('active');
  }

  // 按钮事件监听
  prevBtn.addEventListener('click', function() {
    clearActive();
    currentIndex = (currentIndex - 1 + postItem.length) % postItem.length;
    updateSlider();
  });

  nextBtn.addEventListener('click', function() {
    clearActive();
    // currentIndex = (currentIndex + 1) % postItem.length;
    currentIndex++;
    if (currentIndex > postItem.length - 1) {
      currentIndex = 0;
    }
    updateSlider();
  });

  // 点击滑动列表子项跳转
  carouselItemList.forEach((dot, index) => {
    dot.addEventListener('click', function() {
      currentIndex = index;
      clearActive();
      updateSlider();
    })
  });

  // 切换文本状态
  function checkOverflow() {
    content.forEach(e => {
      toggleBtn = e.querySelector('#toggleMore');
      postContent = e.querySelector('#postContent');

      // 自动检测是否需要显示展开按钮
      if (postContent.scrollHeight > e.clientHeight) {
        postContent.classList.add('expanded');
        toggleBtn.style.display = 'inline-block';
      } else {
        toggleBtn.style.display = 'none';
      }
    });
  }

  // 点击展开
  content.forEach(e => {
    e.addEventListener('click', btn => {
      btn.stopPropagation();//阻止事件冒泡到父元素
      const expandedBtn = btn.target.closest('#toggleMore');
      const expandedContent = expandedBtn.previousElementSibling;
      expandedContent.classList.toggle('expanded');
      expandedBtn.textContent = expandedContent.classList.contains('expanded') ? 'Read more' : 'Show less';
    });
  });

  function clearActive() {
    carouselItemList.forEach(e => {
      e.classList.remove('active');
    });
    checkOverflow();
    content.forEach(e => {
      toggleBtn = e.querySelector('#toggleMore');
      postContent = e.querySelector('#postContent');
      toggleBtn.textContent = postContent.classList.contains('expanded') ? 'Read more' : 'Show less';
    });
  }

});

// 响应式处理
window.addEventListener("resize", () => {
    // 移动端优化处理
    if (window.innerWidth < 768) {
        // 重置移动端动画状态
        document.querySelectorAll("#postContent").forEach((item) => {
            item.classList.remove('expanded');
        });
    } 
});

